import FilterModal from './FilterModal';
import { useDispatch } from 'react-redux';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';
import Search from '@/components/categories/Search';
import { useLazyGetTotalRevenueReportFileQuery } from '@/store/services/reports';
import FilterBtn from '../SharedComponents/FilterBtn';
import ExportBtn from '../SharedComponents/ExportBtn';
import { useTotalRevenueFilters } from '@/store/slices/reportFiltersSlice';

export function Filters() {
  const dispatch = useDispatch();
  const filters = useTotalRevenueFilters();
  const { search } = usePublicState();

  const searchValue = search?.revenueReportSearch || '';

  return (
    <div className="flex items-center justify-between flex-col md:flex-row gap-4">
      <Search searchName="revenueReportSearch" />
      <div className="flex items-center gap-4">
        <FilterBtn
          onClick={() => {
            dispatch(setModalId({ id: 'TOTAL_REVENUE_REPORT_MODAL' }));
          }}
        />

        <ExportBtn
          useQueryHook={useLazyGetTotalRevenueReportFileQuery}
          filters={{ ...filters, search: searchValue }}
        />
      </div>

      <FilterModal />
    </div>
  );
}
